import { Box, Heading, Table, Thead, Tbody, Tr, Th, Td, useDisclosure} from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import AuthContext from '../contexts/AuthContext';
import axios from 'axios';
import AssetDetailsModal from './AssetDetailsModal';

const AssetsTable = ({refresh}) => {

    const [assets, setAssets] = useState([]);
    const {getToken} = useContext(AuthContext);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const {isOpen, onOpen, onClose} = useDisclosure();

    useEffect(() => {
        const fetchData = async () => {
            const token = getToken();
            try {
                const assetsResponse = await axios.get('/api/assets', {
                headers: { Authorization: `Bearer ${token}` }
                });
                setAssets(assetsResponse.data);
            } catch (error) {
                console.error('Failed to fetch data', error);
            }
        };

        fetchData();
    }, [getToken, refresh]);

    const handleRowClick = (asset) => {
        setSelectedAsset(asset);
        onOpen();
    }

    return (
        <Box>
            <Heading size="md" mb={4}>Assets Owned</Heading>
            <Table variant="simple">
            <Thead>
                <Tr>
                    <Th>Ticker</Th>
                    <Th>Name</Th>
                    <Th>Broker</Th>
                    <Th>Quantity</Th>
                    <Th>Currency</Th>
                </Tr>
            </Thead>
            <Tbody>
                {assets.map((asset) => (
                <Tr key={asset.id} onClick={() => handleRowClick(asset)} cursor="pointer">
                    <Td>{asset.ticker}</Td>
                    <Td>{asset.name}</Td>
                    <Td>{asset.broker}</Td>
                    <Td>{asset.quantity}</Td>
                    <Td>{asset.currency}</Td>
                </Tr>
                ))}
            </Tbody>
            </Table>

            {selectedAsset && (
                <AssetDetailsModal asset={selectedAsset} isOpen={isOpen} onClose={onClose} />
            )}
        </Box>
    );
};

export default AssetsTable;